import React from 'react';
import PackageStructure from './PackageStructureBeta';

const SimulationTabContent = ({ packages, expandedPackages, expandedTiers, onTogglePackage, onToggleTier, isVisible, onToggleVisibility, selectedPeriod, onPeriodChange }) => {
    return (
        <div className="simulation-tab-content">
            <PackageStructure
                packages={packages}
                expandedPackages={expandedPackages}
                expandedTiers={expandedTiers}
                onTogglePackage={onTogglePackage}
                onToggleTier={onToggleTier}
                isVisible={isVisible}
                onToggleVisibility={onToggleVisibility}
                selectedPeriod={selectedPeriod}
                onPeriodChange={onPeriodChange}
            />
        </div>
    );
};

export default SimulationTabContent;
